@if (isLoading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<h2 class="banner-title">Message History</h2>
@if (!isLoading) {
  <p-table
    #dt
    [value]="marketingBannerHistory"
    selectionMode="single"
    [loadingIcon]="loadingIcon"
    [showLoader]="true"
    [scrollable]="true"
    [style]="{ width: '100%' }"
    scrollHeight="550px"
    dataKey="marketingBannerID"
    [paginator]="true"
    [rows]="10"
    [pageLinks]="5"
    paginatorPosition="bottom"
    class="table">
    <ng-template #header let-columns>
      <tr class="row">
        <th class="headercell colmedium">Message</th>
        <th class="headercell colmedium">Link to learn more</th>
        <th [pSortableColumn]="'createdOn'" class="headercell">
          Created Date <p-sortIcon [field]="'createdOn'"> </p-sortIcon>
        </th>
        <th class="headercell">Created By</th>
      </tr>
      <tr>
        <th></th>
        <th></th>
        <th class="dashtable colmedium">
          <input
            class="marketing-filter"
            pInputText
            type="text"
            (input)="
              dt.filter($any($event.target).value, 'createdOn', 'contains')
            "
            [value]="
              dt.filters['createdOn'] ? $any(dt.filters['createdOn']).value : ''
            " />
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns">
      <tr class="row">
        <td class="colmedium">
          <span>{{ rowData.description }}</span>
        </td>
        <td class="colmedium">
          <span>{{ rowData.linkToLearnMore }}</span>
        </td>
        <td>
          <span>{{ rowData.createdOn | date: 'yyyy-MM-dd hh:mm a' }}</span>
        </td>
        <td>
          <span>{{ rowData.createdByUser.fullName }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
